import axios from "axios";
import {
  InventoryCategoryApi,
  InventoryCustomerApi,
  InventoryItemApi,
  InventorySubCategoryApi,
} from ".";

export const fetchInventoryCategories = () => {
  return axios
    .get(InventoryCategoryApi)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const fetchInventorySubCategories = () => {
  return axios
    .get(InventorySubCategoryApi)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const fetchInventoryItems = () => {
  return axios
    .get(InventoryItemApi)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const fetchInventoryCustomers = () => {
  return axios
    .get(InventoryCustomerApi)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return [];
    });
};

export const createInventoryCategory = (data) => {
  return axios
    .post(InventoryCategoryApi, data)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const createInventorySubCategory = (data) => {
  return axios
    .post(InventorySubCategoryApi, data)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const createInventoryItem = (data) => {
  return axios
    .post(InventoryItemApi, data)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const createInventoryCustomer = (data) => {
  return axios
    .post(InventoryCustomerApi, data)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const editInventoryItem = (id, data) => {
  return axios
    .put(`${InventoryItemApi}${id}/`, data)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const editInventoryCustomer = (id, data) => {
  return axios
    .put(`${InventoryCustomerApi}${id}/`, data)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const deleteInventoryItem = (id) => {
  return axios
    .delete(`${InventoryItemApi}${id}/`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};

export const deleteInventoryCustomer = (id) => {
  return axios
    .delete(`${InventoryCustomerApi}${id}/`)
    .then((res) => {
      return res.data;
    })
    .catch(() => {
      return null;
    });
};
